export type TDomainType = "SalesOrder" | "ServiceOrder" | "Manufacturing";

export enum ComparisonValidityState {
    Valid = 0,
    Invalid = 1,
    Warning = 2,
}

export interface IComparisonInfo {
    sourcePropertyName: string | null;
    targetPropertyName: string | null;
    sourceValue: string | number | boolean | null;
    targetValue: string | number | boolean | null;
    validity: ComparisonValidityState;
}
